import { Roles } from '@/entities/roles'
import {
  WithdrawsModel,
  WithdrawStatus,
  WithdrawStatusIcons,
  WithdrawStatusTitles,
} from '@/features/withdraws/model'
import { BaseCard } from '@/shared/components'
import { BaseCopyButton } from '@/shared/components/BaseCopyButton/BaseCopyButton'
import { PayoutIcon } from '@/shared/components/icons/PayoutIcon'
import { ItemLayout } from '@/shared/components/ItemLayout/ItemLayout'
import { formatCurrency } from '@/shared/lib/currency'
import { formatRequisite } from '@/shared/lib/requisite/formatRequisite'
import { getBankMeta } from '@/shared/utils/getBankMeta'
import { getShortenId } from '@/shared/utils/getShortenId'
import { useNavigate } from 'react-router-dom'

type Props = {
  withdraw: WithdrawsModel
  userRole: Roles | null
}

export const MobileBlockMerchantWithdraw = ({ withdraw, userRole }: Props) => {
  const navigate = useNavigate()

  const subtitleClasses = 'text-text-secondary'
  const dataClasses = 'font-klein font-medium'
  const dataRowClasses = 'flex justify-between'

  // const aMobileWithdrawMethodName = AMobileWithdrawMethodNames[withdraw.aMobileWithdrawMethodTypeTo]
  const columnsData = [
    {
      title: 'ID сделки:',
      data: withdraw.id,
      copyBnt: true,
    },
     {
      title: 'request_id:',
      data: withdraw.requestId,
      copyBnt: true,
    },
    {
      title: 'Курс:',
      data: withdraw.exchangeRateFromTo ? `${withdraw.exchangeRateFromTo} RUB` : '-',
    },
    {
      title: 'Банк:',
      data: getBankMeta(withdraw.bankToName).title,
    },
    {
      title: 'Реквизит:',
      data: formatRequisite(withdraw.paymentRequisitValue),
    },
    {
      title: 'Сумма к выводу:',
      data: formatCurrency(withdraw.amountTo, withdraw.currencyTo),
    },
  ]

  const createdAt = withdraw.createdAt || ''
  const statusTitle = WithdrawStatusTitles[withdraw.withdrawStatus]
  const iconStatus = WithdrawStatusIcons[withdraw.withdrawStatus]

  const onClickHandler = () => {
    if (userRole === Roles.Trader) return
    navigate(`/payout/${withdraw.id}`)
  }

  return (
    <BaseCard variant="secondary" className="flex flex-col mb-4 last:mb-0 px-5 text-sm">
      <div onClick={onClickHandler}>
        <div className="flex justify-between items-center mb-6">
          <ItemLayout
            icon={<PayoutIcon status={iconStatus} />}
            subtitle={new Date(createdAt).toLocaleString('ru-RU')}
            title={statusTitle}
          />
        </div>

        {withdraw.withdrawStatus !== WithdrawStatus.WaitingProcessing && (
          <div>
            <div className={`${dataRowClasses} mb-4`}>
              <span className="font-klein font-medium text-[18px]">
                {formatCurrency(withdraw.amountFrom, withdraw.currencyFrom)}
              </span>
              <span className="text-text-secondary">
                {formatCurrency(withdraw.amountTo, withdraw.currencyTo)}
              </span>
            </div>

            <div className="flex flex-col gap-[10px] mb-[30px]">
              {columnsData.map((el, i) => (
                <div key={i} className={`${dataRowClasses}`}>
                  <span className={`${subtitleClasses}`}>{el.title}</span>
                  <div className="flex items-center gap-1">
                    <span className={el.copyBnt ? `${dataClasses} text-primary` : `${dataClasses}`}>
                      {el.copyBnt ? getShortenId(el.data, 'long') : el.data}
                    </span>
                    {el.copyBnt && <BaseCopyButton text={el.data} color="primary" size="mini" />}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {withdraw.withdrawStatus === WithdrawStatus.Paid && withdraw.factAmountTo && (
          <div className="pt-4 border-t">
            <span className="block mb-[10px] font-klein font-medium">Фактически выведено:</span>
            <div className="flex justify-between items-center">
              <span className="font-klein font-medium text-[18px]">
                {formatCurrency(withdraw.factAmountTo, withdraw.currencyTo)}
              </span>
              {withdraw.totalCommissionAmount > 0 && (
                <span className="text-text-secondary">
                  Комиссия: {formatCurrency(withdraw.totalCommissionAmount, withdraw.currencyFrom)}
                </span>
              )}
            </div>
          </div>
        )}

        {withdraw.errorMessage && (
          <div className="bg-red-50 mt-4 p-3 border border-error rounded-lg">
            <span className="text-error text-sm">{withdraw.errorMessage}</span>
          </div>
        )}
      </div>
    </BaseCard>
  )
}
